<template>
  <div>
    <b-container>
      <Form :editing="true"></Form>
      <br />
    </b-container>
  </div>
</template>

<script>
import Form from './Form';

export default {
  components: {
    Form,
  },
};
</script>
